import { render, staticRenderFns } from "./plannerCustomGoals.vue?vue&type=template&id=6875e20a"
import script from "./plannerCustomGoals.vue?vue&type=script&lang=js"
export * from "./plannerCustomGoals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports